import { defineMessages } from 'react-intl';
export default defineMessages({
    updateAvailable: {
        id: 'appUpdate.updateAvailable',
        defaultMessage: 'Update available'
    },
    updateAvailableOpenAppStore: {
        id: 'appUpdate.updateAvailableOpenAppStore',
        defaultMessage: 'Tap to open the App Store'
    },
    updateAvailableOpenGooglePlay: {
        id: 'appUpdate.updateAvailableOpenGooglePlay',
        defaultMessage: 'Tap to open Google Play'
    },
    updateAvailableVersion: {
        id: 'appUpdate.updateAvailableVersion',
        defaultMessage: 'Update available: v{version}'
    },
    update: {
        id: 'appUpdate.update',
        defaultMessage: 'Update'
    },
    upgradeRequiredTitle: {
        id: 'appUpdate.upgradeRequiredTitle',
        defaultMessage: 'Update SmartMixin to continue'
    },
    openInBrowser: {
        id: 'appUpdate.openInBrowser',
        defaultMessage: 'Open in browser'
    },
    upgradeRequiredAndroid: {
        id: 'appUpdate.upgradeRequiredAndroid',
        defaultMessage: 'An upgrade of your application is required. Visit Google Play to upgrade.'
    },
    webUpdateAvailable: {
        id: 'appUpdate.webUpdateAvailable',
        defaultMessage: 'A new version of SmartMixin is available. Reload the page to use it.'
    },
    reload: {
        id: 'appUpdate.reload',
        defaultMessage: 'Reload'
    },
    upgradeRequiredIos: {
        id: 'appUpdate.upgradeRequiredIos',
        defaultMessage: 'An upgrade of your application is required. Visit the App Store to upgrade.'
    }
});
